import { EventHandlerMap } from './EventMapEmitter';

export function bindDomEvents<
  T extends EventTarget,
  EventMap extends { [K in keyof EventMap]: Event }
>(subject: T, eventMap: EventHandlerMap<EventMap>): void {
  for (const name in eventMap) {
    if (eventMap.hasOwnProperty(name)) {
      const handler = eventMap[name];
      if (handler instanceof Function) {
        subject.addEventListener(name, handler as EventListener);
      }
    }
  }
}

export function unbindDomEvents<
  T extends EventTarget,
  EventMap extends { [K in keyof EventMap]: Event }
>(subject: T, eventMap: EventHandlerMap<EventMap>): void {
  for (const name in eventMap) {
    if (eventMap.hasOwnProperty(name)) {
      const handler = eventMap[name];
      if (handler instanceof Function) {
        subject.removeEventListener(name, handler as EventListener);
      }
    }
  }
}
